import React,  { Component } from 'react';
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import {withStyles} from '@material-ui/core/styles';
//servicos
import DatasetDynamicService from '../../services/DatasetDynamicService'

require('highcharts/modules/funnel')(Highcharts);
require('highcharts/modules/exporting')(Highcharts);
require('highcharts/modules/export-data')(Highcharts);
require('highcharts/modules/accessibility')(Highcharts);



const useStyles = (theme) => ({
  root: {
    display: 'flex',    
  },

})

class ChartRenderFunnel extends Component {

  constructor(props){
    super(props)
    this.state = {      
      dataset:{},
      options:{},
    }
  }

  componentDidUpdate(prevProps, nextProps) {        
    if(nextProps.options === undefined || nextProps.options.series === undefined) {            
      this.executeQuery(this.props.dataset.id)
    }
  }
  
  executeQuery = (id) => {    
          
    if(!id) return

    const response = DatasetDynamicService.executeQuery({            
      query: "",
      connectorId: "",
      datasetId: id,
    })            
    response
      .then( (resp) => {               
        const lines = resp.data.split("\n");
        const contentReport = [];
        lines.forEach( line => {
          if(line) 
            return contentReport.push(JSON.parse(line))
        })     
               
        let report = JSON.parse(this.props.dataset.report)                
        let manager = JSON.parse(this.props.dataset.managerOptions);

        if(typeof manager === "string"){
          manager = JSON.parse(manager);
        }
        const category =  manager[manager.map( m => m.identify).indexOf("category")]
        const series =  manager[manager.map( m => m.identify).indexOf("series")]
        
        report.series = [{
          name: ' ',
          data: contentReport.map(d => {
            return [d[category.data[0].name], d[series.data[0].name]]}
          )
        }]
        this.setState({options: report})                
      })
      .catch(err => {
        console.error(err)
      })                      
  }

  render(){

    return(
      <div>        
        <HighchartsReact          
            highcharts={Highcharts}          
            options={this.state.options}
          />      
      </div>
    )
  }

}

export default withStyles(useStyles)(ChartRenderFunnel)